export interface FeatureFlag {
    id: number;
    name: string;
    slug: string;
    description: string;
    enabled: boolean;
}

export const FeatureFlagSlug = {
    AUTOMATIC_PAYMENTS: "automatic_payments"
};
